export const FETCH_WELD_PARAMETERS_REQUEST = "FETCH_WELD_PARAMETERS_REQUEST";
export const FETCH_WELD_PARAMETERS_SUCCESS = "FETCH_WELD_PARAMETERS_SUCCESS";
export const FETCH_WELD_PARAMETERS_FAILURE = "FETCH_WELD_PARAMETERS_FAILURE";
export const WELD_PARAMETERS_LOADER_START = "WELD_PARAMETERS_LOADER_START";
export const WELD_PARAMETERS_LOADER_STOP = "WELD_PARAMETERS_LOADER_STOP";

export const UPDATE_RENAME_PASSES = "UPDATE_RENAME_PASSES";
export const PUT_RENAME_LOADER_START = "PUT_RENAME_LOADER_START";
export const PUT_RENAME_LOADER_STOP = "PUT_RENAME_LOADER_STOP";
